export default __webpack_public_path__ + "static/media/send.27cf2187.svg";